import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { TrunkService } from '@voice/services/TrunkService';
import ItemForm from '@voice/components/modal-trunks-create-edit-form';
import AddIpForm from '@voice/components/modal-trunks-add-ip-form';
import i18n from '@app/plugins/i18n';

class TrunkModalService extends ModalService {
  constructor() {
    super(TrunkService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('voice.trunk.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  edit(id, item) {
    return this.$open({
      title: i18n.t('voice.trunk.modal.edit'),
      width: this.size.confirm,
      loading: true,
      render: (h) =>
        h(ItemForm, {
          props: {
            id: id,
            item: item,
            ip_disabled: true
          },

          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  add_ip(item) {
    return this.$open({
      title: i18n.t('shared.component.modal.add_ip'),
      width: this.size.confirm,
      loading: true,
      render: (h) =>
        h(AddIpForm, {
          props: {
            item: item
          },

          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,
      loading: true,
      render: (h) =>
        h(ItemForm, {
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new TrunkModalService();
export { instance as TrunkModalService };
